<template>
  <div class="paypal-checkout">
    <div class="spinner-container" v-if="isLoading">
      <b-loading :is-full-page="true" v-model="isLoading" />
    </div>
    <!-- <ValidationObserver v-slot="{ handleSubmit, invalid }"> -->
    <div class="flex">
      <div class="col">
        <div class="total-indicator">
          <span
            class="total-label is-size-4 is-primary-alt has-text-weight-bold"
            >{{ $t("event.total") }}:</span
          >
          <span class="total-amount is-size-4 is-subtle has-text-weight-bold">
            <ICountUp
              :delay="500"
              :endVal="itemAmount * selectedQty"
              :options="options"
              @ready="onReady"
            />
          </span>
        </div>
        <span class="is-pulled-right">{{ $t("event.tax") }}</span>
      </div>
      <div class="paypal-cta" v-if="needsToAcceptCookies">
        <p class="is-size-6 is-subtle mb-4">
          {{ $t("event.cookies.description") }}
        </p>
        <b-button
          class="button is-primary mb-4"
          icon="fas fa-cog"
          has-icon-right
          @click="spawnConsentPreferences()"
          id="termly-consent-preferences"
        >
          {{ $t("event.cookies.preferences") }}
        </b-button>
      </div>
      <div class="paypal-cta" v-else>
        <div ref="paypal" class="paypal-button-container" />
      </div>
    </div>
    <!-- </ValidationObserver> -->
  </div>
</template>

<style lang="scss" scoped>
// .is-qty-input {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     flex-direction: row;
//     width: auto;
//     input {
//         text-align: center;
//     }
// }
.form__element {
  width: 100% !important;
}
.form {
  width: 100%;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}
.col {
  margin-top: -1rem;
  margin-bottom: 1rem;
  margin-right: 1.5rem;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    margin-right: 0;
    width: 100%;
    margin-bottom: 0;
  }
}

.paypal-cta {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}
.paypal-button-container {
  padding-top: 1rem;
  min-width: 100%;
}
.is-pulled-right {
  color: var(--color-subtle);
  font-size: 0.8rem;
  font-weight: 700;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
.total-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5rem;
  width: 100%;

  // width: 50%;
  // @media screen and (max-width: 767px) {
  //     width: 100%;
  // }
}
.flex {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
}
.flex-col {
  // width: 50%;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.paypal-checkout {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // height: 100
  width: 100%;
  overflow: hidden;
  background: rgba(var(--bg-secondary-rgba), 0.6) !important;
  backdrop-filter: blur(2rem);
  border-radius: var(--radius-md);
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
}
</style>

<script>
// import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
// import { email, max, min, oneOf, required } from "vee-validate/dist/rules";
import { loadScript } from "@paypal/paypal-js";

// extend("required", {
//     ...required,
//     message: "Campo richiesto",
// });

// extend("min", {
//     ...min,
//     message: "Minimo caratteri: {length}",
// });

// extend("max", {
//     ...max,
//     message: "Massimo caratteri: {length}",
// });

// extend("email", {
//     ...email,
//     message: "Indirizzo e-mail non valido.",
// });

// extend("oneOf", {
//     ...oneOf,
//     message: "Paese non valido",
// });
import ICountUp from "vue-countup-v2";
import { apiBaseName } from "~/utils/gql";

export default {
  name: "PaypalCheckout",
  props: {
    seatsTaken: {
      type: Number,
      default: 0,
    },
    totalSeats: {
      type: Number,
      default: 0,
    },
    multiBuy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: "",
    },
    membershipId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    onClickOut: {
      type: Function,
      default: () => {},
    },
    itemAmount: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: "EUR",
    },
    transactionName: {
      type: String,
      default: "",
    },
    eventDay: {
      type: String,
      default: "",
    },
    eventStart: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      needsToAcceptCookies: true,
      seatsOptions: {
        decimalPlaces: 0,
        duration: 0.5,
        useEasing: true,
        useGrouping: true,
        // separator: ",",
        // decimal: ".",
        // prefix: `${this.currency} `,
        suffix: "",
      },
      options: {
        decimalPlaces: 2,
        duration: 0.5,
        useEasing: true,
        useGrouping: true,
        separator: ",",
        decimal: ".",
        prefix: `${this.currency} `,
        suffix: "",
      },
      // activePage: "",
      // paypal: null,
      selectedQty: 1,
      isLoading: false,
      transactionStarted: false,
    };
  },
  components: {
    // ValidationObserver,
    // ValidationProvider,
    ICountUp,
  },
  mounted() {
    this.checkIfCorrectCookiesAreAccepted();
    this.loadPaypal();
    this.$store.commit("setCurrPageTitle", this.$t("event.header"));

    // poll seat availability every 30 seconds
  },
  methods: {
    spawnConsentPreferences() {
      // spawn the modal through displayPreferenceModal, then listen for modal close event and check if the correct cookies are accepted
      if (process.browser) {
        const consentPreferences = localStorage.getItem("TERMLY_API_CACHE");
        // write to consentobj.unclassified and consentobj.essential as true

        if (consentPreferences) {
          let consentObj = JSON.parse(consentPreferences);
          consentObj.TERMLY_COOKIE_CONSENT.value.unclassified = true;
          consentObj.TERMLY_COOKIE_CONSENT.value.essential = true;
          consentObj.TERMLY_COOKIE_CONSENT.value.performance = true;
          localStorage.setItem("TERMLY_API_CACHE", JSON.stringify(consentObj));
        }

        // reload page
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }

      // window.displayPreferenceModal();

      // // check if modal with class t-preference-modal is present in the DOM. when it's not  anymore, check if the correct cookies are accepted, if so, reload the page
      // const checkIfModalIsPresent = setInterval(() => {
      //     // console.log("checking if modal is present");
      //     if (!document.querySelector(".t-preference-modal")) {
      //         // console.log("modal is not present");
      //         clearInterval(checkIfModalIsPresent);
      //         if (this.checkIfCorrectCookiesAreAccepted()) {
      //             // console.log("correct cookies are accepted");
      //             setTimeout(() => {
      //                 window.location.reload();
      //             }, 500);
      //             // window.location.reload();
      //         } else {
      //             // console.log("correct cookies are not accepted");
      //         }
      //     }
      // }, 500);
    },
    checkIfCorrectCookiesAreAccepted() {
      if (process.browser) {
        const consentPreferences = localStorage.getItem("TERMLY_API_CACHE");
        if (consentPreferences) {
          let consentObj = JSON.parse(consentPreferences);

          //consentObj.TERMLY_COOKIE_CONSENT.value.performance

          if (
            consentObj.TERMLY_COOKIE_CONSENT &&
            consentObj.TERMLY_COOKIE_CONSENT.value
            // consentObj.TERMLY_COOKIE_CONSENT.value.analytics &&
            // consentObj.TERMLY_COOKIE_CONSENT.value.marketing
          ) {
            if (
              consentObj.TERMLY_COOKIE_CONSENT.value.unclassified &&
              // consentObj.TERMLY_COOKIE_CONSENT.value.analytics &&
              // consentObj.TERMLY_COOKIE_CONSENT.value.marketing &&
              consentObj.TERMLY_COOKIE_CONSENT.value.performance &&
              // consentObj.TERMLY_COOKIE_CONSENT.value.social_networking &&
              consentObj.TERMLY_COOKIE_CONSENT.value.essential
              // &&
              // consentObj.TERMLY_COOKIE_CONSENT.value.
            ) {
              // write to consentobj.unclassified and consentobj.essential
              // console.log("correct cookies are accepted");
              this.needsToAcceptCookies = false;
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    onReady() {
      this.isLoading = false;
    },
    async createPaymentRequest(
      details,
      data,
      userId,
      eventId,
      membershipId
      // selectedQty
    ) {
      const res = await this.$axios
        .$post(`${apiBaseName}/api/process-payment`, {
          headers: {
            "Content-Type": "application/json",
          },
          details,
          data,
          userId,
          eventId,
          membershipId,
        })
        .then((res) => {
          // console.log("response", res);

          return res;
        })
        .catch((err) => {
          console.log(err);
          window.location.reload();
        });
      if (res && res === "OK") {
        this.isLoading = false;

        window.location.reload();
      }
    },
    async loadPaypal() {
      try {
        // const paypalLoader = await this.$axios
        //     .$post("/api/get-paypal-checkout", {
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //         // payment,
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         // this.$router.push(
        //         //     this.localePath("/u/confirm/expired")
        //         // );
        //     });
        // console.log(paypal);
        // const paypal = paypalLoader.script;
        const paypal = await loadScript({
          // clientId:
          // "AY7ytx585xXTiHI8p50CrHvHX0Gufp8lH-N4eWZlqiikAkvChrJKNdpDE0skhMuFPYjk2yQ2wRFrkSUd",
          clientId:
            "AbzVOXAUAig0bNmjIX5PxuAuBguL-tT364yW6kGL1KwV7KnjOy5JvKImYWIY27njxschw-7YRez7rrlH",
          currency: "EUR",

          // disableFunding: "credit,card",
          // buyerCountry: "",
          // commit: "",
          components: "buttons,applepay",
          disableFunding: "bancontact,eps,giropay,ideal,mybank,p24,sepa,sofort",
          // debug: true,

          // dataClientToken: "",
          // enableFunding: "",
          integrationDate: "2023-08-26",
          // intent: "",
          locale: this.$i18n.locale === "it" ? "it_IT" : "en_US",
        });
        if (paypal) {
          try {
            await paypal
              .Buttons({
                onApprove: (data, actions) => {
                  // console.log("onApprove", data, actions);
                  return actions.order.capture().then((details) => {
                    paypal.Buttons().close();
                    // console.log("onApprove", details);
                    // console.log(
                    //     "Transaction completed by " +
                    //         details.payer
                    //             .email_address +
                    //         " order ID: " +
                    //         data.orderID
                    // );
                    // console.log("data", data);
                    // console.log("actions", actions);
                    // // console.log("actions", );
                    // console.log(
                    //     "this.userId",
                    //     this.userId
                    // );
                    // console.log(
                    //     "this.eventId",
                    //     this.eventId
                    // );
                    // console.log(
                    //     "this.membershipId",
                    //     this.membershipId
                    // );
                    // get confirmation email

                    this.createPaymentRequest(
                      details,
                      data, //user
                      this.userId,
                      this.eventId,
                      this.membershipId
                      // this.selectedQty,
                    );
                  });
                },
                onCancel(
                  data,
                  actions // this is the same as the onApprove function
                ) {
                  // console.log("onCancel");
                  // console.log("data", data);
                  // console.log("actions", actions);
                  // cant access this here, so I pass it as a prop

                  // const $nuxt = $nuxt;
                  //is  loading
                  //full url
                  // actions.redirect(
                  //     `${window.location.href}/failed`
                  // );
                  this.isLoading = false;
                  this.transactionStarted = false;

                  // refresh the page to reset the state
                  // don't use this.$router.push() because it will not refresh the page
                  window.location.reload();
                },
                onError(error) {
                  console.error("onError", error);
                  window.location.reload();
                },
                onInit: (data, actions) => {
                  // console.log("onInit", data, actions);
                },
                onClick: (data, actions) => {
                  if (data.fundingSource === "paypal") {
                    this.isLoading = true;
                  }
                  // this.isLoading = true;
                  this.transactionStarted = true;
                },
                createOrder: (data, actions) => {
                  // console.log("createOrder", data, actions);
                  return actions.order.create({
                    application_context: {
                      shipping_preference: "NO_SHIPPING",
                    },
                    purchase_units: [
                      {
                        items: [
                          {
                            name: `${this.$t("event.ticket")} '${
                              this.transactionName
                            }' - ${this.eventDay} ${this.eventStart}`,
                            unit_amount: {
                              currency_code: "EUR",
                              value: this.itemAmount,
                            },
                            quantity: this.selectedQty,
                          },
                        ],
                        // description: `Digital ticket for the event ${this.transactionName}`,
                        amount: {
                          value: this.itemAmount * this.selectedQty,
                          breakdown: {
                            item_total: {
                              currency_code: "EUR",
                              value: this.itemAmount * this.selectedQty,
                            },
                          },
                        },
                      },
                    ],
                  });
                },
                style: {
                  color: "gold", //| "blue" | "silver" | "white" | "black";
                  height: 55, //| 35 | 40 | number;
                  label: "pay", // "checkout" | "buynow" | "pay" | "installment" | "subscribe" | "donate",
                  layout: "vertical", // "horizontal";
                  shape: "pill", // "rect";
                  // tagline: true,
                },
              })
              .render(this.$refs.paypal);
          } catch (error) {
            console.error("failed to render the PayPal Buttons", error);
          }
        }
      } catch (error) {
        console.error("failed to load the PayPal JS SDK script", error);
      }
    },
  },
};
</script>